export default __webpack_public_path__ + "static/media/copy.a09b9030.svg";